<template>
    <popup-modal ref="popup" class="box">
        <div class="demo">
            <div class="d-flex">
                <div class="d-flex align-items-center cursor mr-2 mr-sm-0" @click="close"><span><i class="fa fa-times"></i></span></div>
                <div>
                    <p>
                        Welcome to QR API! Get started by 
                        <strong><a class="color" 
                            href="https://support.qrapi.io/hc/en-us/articles/36460699189273-API-Key" 
                            target="_blank" 
                            @click="close">creating your API Key</a></strong> and 
                        <strong><a 
                            class="color" 
                            href="https://support.qrapi.io/hc/en-us/articles/36460699189273-API-Key" 
                            target="_blank"
                             @click="close">using it.</a></strong>
                        <br/>
                        You can also visit our support section for more information. <strong class="color cursor" @click="redirectToSupport">Visit Support</strong>
                    </p>
                </div>
            </div>

        </div>
    </popup-modal>
</template>

<script>
export default {
    components : {
        PopupModal: () => import(/*webpackChunkName: "PopupModal"*/ './PopupModal.vue')
    },
    methods : {
        show(){
            this.$refs.popup.open();
            this.$gtag.event('Successful Signup',{
              'Event_Definition'   : '',
              'Event_Nomenclature' : 'qrapi-successful-signup' 
            });
        },
        close(){
            this.$refs.popup.close();
        },
        redirectToSupport(){
            this.$router.push({
            name : 'dashboard-support'
          });
          this.close();
        }
    }
}
</script>

<style scoped lang="scss">

.color {
    color : #fc8829;
}

.demo {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;

    padding: 10px 15px;
    border-radius: 10px;
    min-width: 645px !important;
}

.demo p {
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

@media (max-width: 586px) {
        
    /deep/.window {
        border-radius: 10px;
    }
    .demo {
        min-width: 300px !important;
        max-width: 340px !important;
        margin: auto !important;
    }

    .demo p {
        margin-left: 5px;
    }
}

@media only screen and (min-width: 1080px) {
    /deep/.window {
    width: 645px !important;
    top: 28px !important;
    right: 24% !important;
    border-radius: 10px;
  }
}
</style>